export const srollToTop = (): void => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
};
